var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "widget" },
    [
      [
        _c("ul", { staticClass: "nav nav-tabs", attrs: { role: "tablist" } }, [
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.activeName == "ActionTracker" },
              attrs: { role: "presentation" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  attrs: { role: "tab", "data-toggle": "tab" },
                  on: {
                    click: function ($event) {
                      return _vm.setTab("ActionTracker")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "dashboard-icons",
                    attrs: {
                      src: "/static/images/icons/submission_icon_blue.svg",
                    },
                  }),
                  _vm._v(" Activity Tracker "),
                ]
              ),
            ]
          ),
          _c(
            "li",
            {
              staticClass: "nav-item",
              class: { active: _vm.activeName == "DueDates" },
              attrs: { role: "presentation" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  attrs: { role: "tab", "data-toggle": "tab" },
                  on: {
                    click: function ($event) {
                      return _vm.setTab("DueDates")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "dashboard-icons",
                    attrs: { src: "/static/images/icons/sb_due_date.svg" },
                  }),
                  _vm._v(" Due Dates "),
                ]
              ),
            ]
          ),
        ]),
      ],
      _c("div", { staticClass: "dashboard-widget-bodies" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selectedMenu === "ActionTracker",
                expression: "selectedMenu === 'ActionTracker'",
              },
            ],
          },
          _vm._l(_vm.activityData, function (items, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "dashboard-widget-body",
                attrs: { "data-tab": "tracker", "data-widget": "2" },
              },
              [
                _c("h3", [_vm._v(_vm._s(_vm._f("capitalize")(index)))]),
                items.length == 0 && index == "today"
                  ? _c("div", [
                      _c("div", { staticClass: "empty-data" }, [
                        _vm._v("There has been no activity today."),
                      ]),
                    ])
                  : _vm._e(),
                items.length == 0 && index == "yesterday"
                  ? _c("div", [
                      _c("div", { staticClass: "empty-data" }, [
                        _vm._v("There has been no activity yesterday."),
                      ]),
                    ])
                  : _vm._e(),
                _vm._l(items, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.projectId,
                      staticClass: "row dashboard-widget-due-date",
                    },
                    [
                      _c("div", { staticClass: "col-xs-11" }, [
                        item.type === "ADDED_COMMENT"
                          ? _c("div", { staticClass: "display-inline" }, [
                              _c("div", { staticClass: "widget-icon" }, [
                                _c("i", { staticClass: "fa fa-comment-o" }),
                                _c("span", { staticClass: "badge" }, [
                                  _vm._v(_vm._s(item.count)),
                                ]),
                              ]),
                              _c(
                                "a",
                                {
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.redirect(item.nextUrl)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.title) + " has new comments"
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        item.type === "EXPORT_QUEUED"
                          ? _c("div", { staticClass: "display-inline" }, [
                              _vm._m(0, true),
                              _c(
                                "a",
                                {
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.redirect(item.nextUrl)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.title) + " has been exported"
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          }),
          0
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selectedMenu === "DueDates",
                expression: "selectedMenu === 'DueDates'",
              },
            ],
          },
          _vm._l(_vm.dueData, function (items, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "dashboard-widget-body",
                attrs: { "data-tab": "tracker", "data-widget": "2" },
              },
              [
                _c("h3", [_vm._v(_vm._s(_vm._f("capitalize")(index)))]),
                items.length == 0 && index == "today"
                  ? _c("div", [
                      _c("div", { staticClass: "empty-data" }, [
                        _vm._v("There are no nodes due today."),
                      ]),
                    ])
                  : _vm._e(),
                items.length == 0 && index == "soon"
                  ? _c("div", [
                      _c("div", { staticClass: "empty-data" }, [
                        _vm._v(
                          "There are no nodes due within the next 60 days."
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._l(items, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "row dashboard-widget-due-date",
                    },
                    [
                      _c("div", { staticClass: "col-xs-11 display-inline" }, [
                        _vm._m(1, true),
                        _c(
                          "a",
                          {
                            staticClass: "cursor-pointer",
                            on: {
                              click: function ($event) {
                                return _vm.redirect(item.nextUrl)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(item.title) + " is due " + _vm._s(item.due)
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          }),
          0
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "widget-icon" }, [
      _c("img", {
        staticClass: "calender-icon",
        attrs: { src: "/static/images/icons/export.svg" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "widget-icon" }, [
      _c("img", {
        staticClass: "calender-icon",
        attrs: { src: "/static/images/icons/calender_icon.svg" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }